import "antd/dist/antd.min.css";
import { Image, Rate, Button, InputNumber, Radio } from "antd";
import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { StarFilled } from "@ant-design/icons";
import { priceFormat, queryParams } from "../utils";
import { store } from "../app/store";
import { buyNow, saveDrugStore } from "../app/features/cart";
import SImage from "./SImage";

const renderRow = (title, content) => {
  return (
    <p className="flex flex-row font-light">
      {title}:<p className="ml-1.5 font-bold">{content}</p>
    </p>
  );
};
const scrollTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
const Time = (time) => {
  if (time <= 24) {
    return time + " Giờ Làm Việc";
  } else if (time%24 === 0){
    return Math.floor(time / 24) + " Ngày Làm Việc" ;
  } else {
    return Math.floor(time / 24) + " Ngày " + (time % 24) + " Giờ Làm Việc";
  }
};

export default function AgentsProductItem({ agentproduct }) {
  let [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const onBuyNow = (indexUnit) => {
    store.dispatch((dispatch, getState) =>
      buyNow(
        dispatch,
        getState,
        {
          unit_id: agentproduct.units[indexUnit]?.id,
          drug_id: agentproduct.drug_id,
          drug_store_id: agentproduct.drug_store_id,
          quantity: 1,
        },
        () => {
          dispatch(saveDrugStore(agentproduct.drug_store_id));
          navigate("/cart");
        }
      )
    );
  };

  return (
    <>
      <div className="flex flex-row flex-wrap sm:flex-nowrap p-3 mb-4 bg-white shadow-lg rounded-[12px] items-center">
        <SImage
          className="h-[103px] sm:basis-[243px] sm:h-[161px] object-cover basis-[50%] block"
          src={agentproduct.drug_store_avatar}
        />
        <div className="flex flex-col pl-[10px] sm:pl-[0px] sm:mx-6 basis-[50%] sm:basis-[500px]">
          <Link to={`/agency-details?agencyId=${agentproduct.drug_store_id}`}>

            <p className="text-[10px] sm:text-base font-bold text-two-lines">
              {agentproduct.drug_store_name}
            </p>{" "}
          </Link>
          <div className="flex items-center text-[10px] sm:text-base font-semibold "></div>
          <div className="flex items-center text-[10px] sm:text-sm font-semibold ">
            <StarFilled className="mr-2 text-yellow-300" />
            {agentproduct.star !== null ? agentproduct.star : ""}
          </div>
          <p className="text-[10px] sm:text-sm text-[#000000] font-normal ">
            Địa chỉ : {agentproduct.drug_store_address}
          </p>
          <p className="text-[10px] sm:text-sm text-[#000000] font-normal ">
            Số lượng đã bán: {agentproduct.countTotalSell}
          </p>
        </div>
        <div className="w-[1px] h-200 bg-gray-2 hidden sm:flex mr-[80px]" />
        <div className="grid grid-cols-2 basis-[100%]">
          <div className="flex col-span-2 text-center my-[10px] sm:my-[0px] sm:border-none border-solid border-t-[1px] border-b-[1px] border-[#D9D9D9]">
            <div className="text-[10px] sm:text-sm sm:text-start text-gray-2 flex-1 py-[7px]">
              Đại lý:
              <Link to={`/agency-details?agencyId=${agentproduct.drug_store_id}`}>
                <p className="truncate max-w-[200px] font-bold text-black">
                  {agentproduct.drug_store_name}
                </p>
              </Link>
            </div>
            <div className="text-[10px] sm:text-sm sm:text-start text-gray-2 flex-1 py-[7px] sm:border-none border-solid border-l-[1px] border-[#D9D9D9]">
              Giao hàng:
              {agentproduct.time_delivery && (
              <p className="font-bold text-black">
                {Time(agentproduct.time_delivery)}
              </p>
              )}
            </div>
          </div>
          <div className="col-span-1 grid gap-1">
            {agentproduct.units?.map((item) => (
              <Button
                onClick={() => {
                  let params = queryParams({
                    drugId: agentproduct.drug_id,
                    unitId: item.id,
                  });
                  setSearchParams(params);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className="text-[10px] sm:text-sm text-white rounded-3xl max-w-[155px] h-[38px] font-bold hover:text-white bg-main-blue hover:bg-main-blue active:bg-main-blue focus:bg-main-blue hover:border-main-blue active:text-white  active:border-main-blue focus:border-main-blue focus:text-main-white block mx-auto sm:mx-0"
              >
                {priceFormat(item?.out_price)}/{item?.name}
              </Button>
            ))}
          </div>
          <div className="col-span-1 grid gap-1">
            {agentproduct.units?.map((item, index) => (
              <Button
                onClick={() => onBuyNow(index)}
                className="text-[10px] sm:text-sm text-white rounded-3xl w-[155px] h-[38px] font-bold hover:text-white bg-main-blue hover:bg-main-blue active:bg-main-blue focus:bg-main-blue hover:border-main-blue active:text-white  active:border-main-blue focus:border-main-blue focus:text-main-white block mx-auto sm:mx-0"
              >
                Mua ngay
              </Button>
            ))}
          </div>

        </div>
      </div>
    </>
  );
}
